import { SetStateAction, Dispatch, useState } from 'react';
import { usePrevious } from './usePrevious';

export const usePreviousState = <T>(initialValue: T): [T, Dispatch<SetStateAction<T>>, T | undefined] => {
    const [value, setValue] = useState(initialValue);
    const previous = usePrevious(value);

    return [value, setValue, previous];
};
